export const COLOR_VARIANTS = {
  blue: {
    bar: "bg-blue-500",
    topAccent: "bg-blue-500",
    border: "border-blue-500",
    iconBg: "bg-blue-100",
    iconText: "text-blue-600",
    btn: "text-blue-600 bg-blue-50/80 hover:bg-blue-100 border border-blue-100",
    badge: "text-blue-700 bg-blue-50 border-blue-200/80",
    glow: "bg-blue-50",
    dot: "bg-blue-500",
  },
  orange: {
    bar: "bg-orange-500",
    topAccent: "bg-orange-500",
    border: "border-orange-500",
    iconBg: "bg-orange-100",
    iconText: "text-orange-600",
    btn: "text-orange-600 bg-orange-50/80 hover:bg-orange-100 border border-orange-100",
    badge: "text-orange-700 bg-orange-50 border-orange-200/80",
    glow: "bg-orange-50",
    dot: "bg-orange-500",
  },
  purple: {
    bar: "bg-purple-500",
    topAccent: "bg-purple-500",
    border: "border-purple-500",
    iconBg: "bg-purple-100",
    iconText: "text-purple-600",
    btn: "text-purple-600 bg-purple-50/80 hover:bg-purple-100 border border-purple-100",
    badge: "text-purple-700 bg-purple-50 border-purple-200/80",
    glow: "bg-purple-50",
    dot: "bg-purple-500",
  },
  emerald: {
    bar: "bg-emerald-500",
    topAccent: "bg-emerald-500",
    border: "border-emerald-500",
    iconBg: "bg-emerald-100",
    iconText: "text-emerald-600",
    btn: "text-emerald-600 bg-emerald-50/80 hover:bg-emerald-100 border border-emerald-100",
    badge: "text-emerald-700 bg-emerald-50 border-emerald-200/80",
    glow: "bg-emerald-50",
    dot: "bg-emerald-500",
  },
  red: {
    bar: "bg-red-500",
    topAccent: "bg-red-500",
    border: "border-rose-500",
    iconBg: "bg-red-100",
    iconText: "text-red-600",
    btn: "text-red-600 bg-red-50/80 hover:bg-red-100 border border-red-100",
    badge: "text-red-700 bg-red-50 border-red-200/80",
    glow: "bg-red-50",
    dot: "bg-red-500",
  },
  gray: {
    bar: "bg-slate-500",
    topAccent: "bg-slate-500",
    border: "border-slate-400",
    iconBg: "bg-slate-100",
    iconText: "text-slate-600",
    btn: "text-slate-600 bg-slate-50/80 hover:bg-slate-100 border border-slate-200",
    badge: "text-slate-700 bg-slate-50 border-slate-200/80",
    glow: "bg-slate-50",
    dot: "bg-slate-500",
  },
};

export const formatChatTimestamp = (dateInput) => {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  const now = new Date();
  const timeStr = date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfMsgDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const diffDays = Math.round((startOfToday - startOfMsgDay) / (1000 * 60 * 60 * 24));

  if (diffDays === 0) {
    return timeStr;
  } else if (diffDays === 1) {
    return `Yesterday, ${timeStr}`;
  } else if (diffDays > 1 && diffDays < 7) {
    const dayName = date.toLocaleDateString([], { weekday: "short" });
    return `${dayName}, ${timeStr}`;
  } else {
    const sameYear = now.getFullYear() === date.getFullYear();
    const dateStr = date.toLocaleDateString([], {
      month: "short",
      day: "numeric",
      ...(sameYear ? {} : { year: "numeric" }),
    });
    return `${dateStr}, ${timeStr}`;
  }
};
